import React from 'react';
import { TouchableOpacity } from 'react-native';
import Icon from '../../icon/Icon';
import Typography from '../../typography/Typography';
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
const LendingPartnerContent = ({ label, action, triggerAction, }) => {
    return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }, onPress: () => {
            action();
        } },
        React.createElement(Typography, { label: label, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
        React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night })));
};
export default LendingPartnerContent;
